var Decoder = require('./decode');

var Encoder = require('./encode');

exports.decode = function (opts) {
  return new Decoder(opts);
};

exports.encode = function (opts) {
  return new Encoder(opts);
};